import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  actionsContainer: {
    display: "flex",
    justifyContent: "space-around",
    "& > button": {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
}));

export default ({ children }) => {
  const classes = useStyles();
  return <div className={classes.actionsContainer}>{children}</div>;
};
